import { isLocaleCode as u } from "./assertions.js";
import { orderedLocaleCodes as o, localeCodeMap as l, locales as e } from "./constants.js";
var h = Object.defineProperty, f = (n, i, r) => i in n ? h(n, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : n[i] = r, t = (n, i, r) => f(n, typeof i != "symbol" ? i + "" : i, r);
const p = [
  "DZ",
  "BH",
  "KM",
  "DJ",
  "EG",
  "IQ",
  "JO",
  "KW",
  "LB",
  "LY",
  "MR",
  "MA",
  "OM",
  "PS",
  "QA",
  "SA",
  "SO",
  "SD",
  "SY",
  "TN",
  "AE",
  "YE"
];
function g(n) {
  switch (n.toUpperCase()) {
    case "JP":
      return [e.japanese.code];
    case "KR":
      return [e.korean.code];
    case "CN":
      return [e.chineseSimplified.code, e.chineseTraditional.code];
    case "TW":
    case "HK":
      return [e.chineseTraditional.code, e.chineseSimplified.code];
    case "MO":
      return [
        e.chineseTraditional.code,
        e.chineseSimplified.code,
        e.english.code,
        e.portuguese.code
      ];
    case "SG":
      return [
        e.english.code,
        e.chineseTraditional.code,
        e.chineseSimplified.code
      ];
    case "TH":
      return [
        e.thai.code,
        e.english.code,
        e.chineseSimplified.code,
        e.chineseTraditional.code
      ];
    case "ID":
      return [
        e.indonesian.code,
        e.english.code,
        e.chineseSimplified.code,
        e.chineseTraditional.code
      ];
    case "MY":
      return [
        e.malay.code,
        e.english.code,
        e.chineseSimplified.code,
        e.chineseTraditional.code
      ];
    case "LA":
      return [
        e.lao.code,
        e.english.code,
        e.chineseSimplified.code,
        e.chineseTraditional.code
      ];
    case "VN":
      return [
        e.vietnamese.code,
        e.english.code,
        e.chineseSimplified.code,
        e.chineseTraditional.code
      ];
    case "DE":
    case "AT":
      return [e.german.code];
    case "ES":
    case "MX":
      return [e.spanish.code];
    case "FR":
      return [e.french.code];
    case "PT":
    case "BR":
      return [e.portuguese.code];
    case "IT":
      return [e.italian.code];
    case "RU":
      return [e.russian.code];
    case "PH":
      return [e.tagalog.code];
    case "IL":
      return [e.hebrew.code];
    case "IN":
      return [e.hindi.code];
    case "KH":
      return [e.khmer.code];
    case "NL":
    case "BE":
      return [e.dutch.code];
    case "TR":
      return [e.turkish.code];
    default:
      return p.includes(n.toUpperCase()) ? [e.arabic.code] : [];
  }
}
function m({
  locale: n,
  availableLocales: i,
  preferredLocales: r
}) {
  var s;
  const c = r.filter(
    (a) => i.includes(a)
  );
  return !u(n) || !i.includes(n) ? (s = c[0]) != null ? s : r[0] : n;
}
function L(n) {
  if (!n)
    return o;
  const i = g(n);
  return [
    ...i,
    ...o.filter((r) => !i.includes(r))
  ];
}
function _({
  locale: n,
  country: i,
  availableLocales: r
}) {
  const s = L(i).filter(
    (c) => r.includes(c)
  );
  return {
    locale: m({ locale: n, availableLocales: r, preferredLocales: s }),
    supportedLngs: s
  };
}
class S {
  constructor(i) {
    t(this, "supported"), t(this, "normalized"), t(this, "aliases"), this.aliases = /* @__PURE__ */ new Map(), this.supported = new Set(i), this.normalized = /* @__PURE__ */ new Map(), i.forEach((r) => {
      var s, c;
      this.normalized.set(r.toLowerCase(), r), (c = (s = l.get(r)) == null ? void 0 : s.aliases) == null || c.forEach((a) => {
        this.aliases.set(a.toLowerCase(), r);
      });
    });
  }
  parse(i) {
    if (!i) return;
    const r = i.split(",").map((s) => s.split(";")[0]).filter((s) => !!s);
    for (const s of r) {
      const c = this.checkLanguage(s);
      if (c) return c;
    }
  }
  checkLanguage(i) {
    var r, s;
    const { full: c, short: a, first: d } = this.normalizeLanguage(i);
    return (s = (r = this.tryLanguage(c)) != null ? r : this.tryLanguage(a)) != null ? s : this.tryLanguage(d);
  }
  normalizeLanguage(i) {
    const r = i.trim().toLowerCase().replace(/_/g, "-"), [s, c] = r.split("-");
    return { full: r, first: s, short: c ? `${s}-${c}` : s };
  }
  tryLanguage(i) {
    const r = this.normalized.get(i);
    if (r && this.supported.has(r)) return r;
    const s = this.aliases.get(i);
    if (s && this.supported.has(s)) return s;
  }
}
function v(n) {
  const i = new S(n);
  return (r) => i.parse(r);
}
export {
  v as configureAcceptLanguageParser,
  _ as resolveLocaleConfig
};
